import { reduxKey } from './constants';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { flagEnabled } from '../flags/selectors';
var getStoreSlice = function (state) { return state[reduxKey]; };
export var isExperimentActive = function (state) {
    return flagEnabled(state, 'sisu_funnel_1') ||
        flagEnabled(state, 'sisu_funnel_2') ||
        flagEnabled(state, 'sisu_funnel_3');
};
export var isBannerVisible = function (state) {
    if (getIsLoggedIn(state)) {
        return false;
    }
    if (flagEnabled(state, 'sisu_funnel_1')) {
        // Always enabled in first test
        return true;
    }
    if (flagEnabled(state, 'sisu_funnel_2') ||
        flagEnabled(state, 'sisu_funnel_3')) {
        // Tests 2 and 3 must show the banner explicitly at some point
        return getStoreSlice(state).visible;
    }
    return false;
};
//# sourceMappingURL=selectors.js.map